import { ActionIcon, Box, Image, Tooltip } from "@mantine/core";
import bgImg from "assets/images/pngs/Rank-Status.png";
import IconCard from "@/assets/images/pngs/iconcard.png";
import IconCopy from "@/assets/images/pngs/copy.png";
import { useState } from "react";

const AccountCard = ({ title, description, detail, icon }: any) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(String(title ?? ""));
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // optional: fallback for older browsers
      console.error("copy failed", err);
    }
  };
  return (
    <Box
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "20px 16px",
        borderRadius: "8px",
        backgroundImage: `url(${bgImg})`,
        backgroundSize: "100% 100%",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        color: "white",
      }}
    >
      <Box>
        <Image src={icon || IconCard} alt="Card Icon" width={56} height={56} />
      </Box>
      <Box>
        <Box
          style={{
            fontWeight: 700,
            fontSize: "16px",
            textTransform: "uppercase",
          }}
        >
          {description}
        </Box>
        <Box
          style={{
            fontSize: "14px",
            color: "#FFFFFFCC",
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          {/* {description} */}
          STK: {title}
          <Tooltip label={copied ? "Copied" : "Copy"} withArrow>
            <ActionIcon
              variant="transparent"
              onClick={handleCopy}
              aria-label="Copy account number"
              size={20}
              style={{ padding: 0, marginLeft: 4 }}
            >
              <Image src={IconCopy} alt="Copy Icon" width={16} height={16} />
            </ActionIcon>
          </Tooltip>
        </Box>
        <Box
          style={{
            fontSize: "14px",
            color: "#FFFFFFCC",
          }}
        >
          {detail}
        </Box>
      </Box>
    </Box>
  );
};

export default AccountCard;
